/**
 * Flow Selectors
 *
 * Memoized selectors for accessing onboarding flow state.
 * Using createSelector ensures components only re-render when selected data changes.
 */
import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/store';

// ============================================
// Base Selectors
// ============================================

const selectFlowState = (state: RootState) => state.onboarding.flow;

// ============================================
// Flow Selectors (Memoized)
// ============================================

export const selectCurrentStep = createSelector([selectFlowState], (flow) => flow.currentStep);

// ============================================
// Recommendations Selectors (Memoized)
// ============================================

export const selectRecommendations = createSelector(
  [selectFlowState],
  (flow) => flow.recommendations,
);

export const selectRecommendationsLoading = createSelector(
  [selectFlowState],
  (flow) => flow.isRecommendationsLoading,
);

export const selectRecommendationsError = createSelector(
  [selectFlowState],
  (flow) => flow.recommendationsError,
);
